
import { Input, Checkbox, CheckboxGroup } from "element-ui"
import eventBus from "./eventBus.js"

export default {
  name: "WareViewFilterBox",
  components: {
    [Input.name]: Input,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup
  },
  props: {
    filterProperty: {
      type: Array,
      default: () => []
    },
    category: {
      type: Object,
      default: () => {}
    },
    filterValue: {
      type: [],
      default: () => []
    }
  },
  data() {
    return {
      filterInput: {},
      activeCategoryId: "",
      switchVal: 0,
      categoryIdStack: [],
      filterData: [],
      checkedFilter: [],
      checkListMap: {},
      INIT_SHOW_NUM: 5,
      showMoreMap: {},
      cateList: []
    }
  },

  computed: {},
  watch: {
    category: {
      handler(newVal) {
        if (!newVal) return
        const { childList, name, path, isLeaf } = newVal
        this.activeCategoryId = path.length ? path[path.length - 1] : ""
        this.categoryIdStack = [...path]
        this.cateList = [...childList]
        const prevId = path.length > 2 ? path[path.length - 2] : ""
        const allId = isLeaf ? prevId : this.activeCategoryId
        this.cateList.unshift({
          categoryId: allId,
          realyName: name,
          categoryLevel: path.length,
          categoryName: this.$t("category.all")
        })
      },
      immediate: true
    },
    filterProperty: {
      handler(newVal) {
        this.checkListMap = {}
        this.totalNum = 0
        const filterData = []
        newVal.forEach(v => {
          const item = {
            ...v,
            originChildProperties: v.childProperties
          }
          if (v.propertyId == 3) {
            filterData.unshift(item)
          } else {
            filterData.push(item)
          }
        })
        this.filterData = filterData
        this.initCheckListMap(newVal)
      },
      immediate: true
    },
    filterValue: {
      handler(newVal) {
        const result = []
        newVal.forEach(item => {
          const childItem = this.filterProperty.find(v => v.propertyId === item.proCatId) || { childProperties: [] }
          const propertyName = childItem.childProperties.find(v => v.propertyId === item.proId)?.propertyName
          result.push({
            proCatId: item.proCatId,
            propertyId: item.proId,
            propertyName
          })
        })
        this.$nextTick(() => {
          this.checkedFilter = result
          this.updateCheckListMap(this.checkedFilter)
        })
      },
      immediate: true,
      deep: true
    },
    checkedFilter: {
      handler(newVal) {
        eventBus.$emit("check-filter", newVal)
      },
      immediate: true
    }
  },

  created() {
    eventBus.$on("clear-filter", item => {
      this.checkListMap[`${item.proCatId}`] = this.checkListMap[`${item.proCatId}`].filter(v => v !== item.propertyId)
      this.handleCheckboxChanged(false, item)
      this.$emit("change", this.getEmitParams())
    })
    eventBus.$on("clear-all", item => {
      Object.keys(this.checkListMap).forEach(key => {
        this.checkListMap[key] = []
      })
      this.checkedFilter = []
      this.$emit("change", this.getEmitParams())
    })
  },
  beforeDestroy() {
    eventBus.$off("clear-filter")
    eventBus.$off("clear-all")
  },

  methods: {
    handleChanged(val, index) {
      if (val) {
        this.filterData[index].childProperties = this.filterData[index].originChildProperties.filter(v => {
          const propertyName = v.propertyName ? v.propertyName.toUpperCase() : ""
          return propertyName.includes(val.toUpperCase())
        })
      } else {
        this.filterData[index].childProperties = this.filterData[index].originChildProperties
      }
    },
    initCheckListMap(data) {
      data.forEach((v, i) => {
        this.$set(this.checkListMap, `${v.propertyId}`, [])
        this.$set(this.showMoreMap, i, false)
      })
      if (this.checkedFilter) {
        this.updateCheckListMap(this.checkedFilter)
      }
    },
    updateCheckListMap(checkedArray) {
      Object.keys(this.checkListMap).forEach(key => {
        const values = checkedArray.filter(item => item.proCatId == key).map(item => item.propertyId)
        this.checkListMap[key] = values
      })
    },
    getEmitParams() {
      const filterProperties = this.checkedFilter.map(v => ({
        proCatId: v.proCatId,
        proId: v.propertyId
      }))
      if (this.switchVal) {
        filterProperties.push({
          proCatId: 3,
          proId: this.switchVal
        })
      }
      return {
        filterProperties
      }
    },
    handleCheckboxChanged(val, data) {
      if (val) {
        this.checkedFilter.push(data)
      } else {
        this.checkedFilter = this.checkedFilter.filter(v => v.propertyId != data.propertyId)
      }
      // this.getTotalNum()
      this.$emit("change", this.getEmitParams())
    },
    handleClearItem(item) {
      this.checkListMap[`${item.propertyId}`] = this.checkListMap[`${item.propertyId}`].filter(
        v => v !== item.propertyId
      )
      this.handleCheckboxChanged(false, item)
      this.$emit("change", this.getEmitParams())
    },
    handleSwitchChanged() {
      // this.getTotalNum()
      this.$emit("change", this.getEmitParams())
    },
    handleShowMore(index) {
      this.showMoreMap[index] = !this.showMoreMap[index]
    },
    genCategoryUrl(val) {
      let categoryIdArray = []
      if (this.categoryIdStack.includes(val.categoryId)) {
        categoryIdArray = this.categoryIdStack.slice(0, this.categoryIdStack.indexOf(val.categoryId) + 1)
      } else if (this.categoryIdStack.length === 3) {
        categoryIdArray = this.categoryIdStack.slice(0, 2).concat(val.categoryId)
      } else {
        categoryIdArray = this.categoryIdStack.concat(val.categoryId)
      }
      return {
        name: this.$route.name,
        params: {
          categoryId: categoryIdArray.join("-"),
          page: 1
        }
      }
    }
  }
}
